import { Inter } from 'next/font/google';

const inter = Inter({
  subsets: ['latin'],
  variable: '--font-inter',
  weight: 'variable',
});

/**
 * Retrieves the font variables.
 * @returns {string} All the font variables combined.
 */
const getFontVariables = () => {
  return `${inter.variable} font-sans`;
};

export default getFontVariables;
